module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/digital-realities-what-is-ar.json
// module id = 426
// module chunks = 143507134358403